export const transformUser = (user) => {
    
    if (!user?.id) {
        return null;
    }
    let label = "";
    if (user.firstName && user.firstName.length > 0) {
        label = user.firstName;
    }
    if (user.lastName && user.lastName.length > 0) {
        label += label ? " " : "";
        label += user.lastName;
    }
    if (label.length > 0) {
        label += ` (${user.login})`;
    } else {
        label = user.login;
    }

    return {
        value: user.id,
        label: label,
        ...user
    };
};
